import React, {useContext, useEffect, useState} from 'react'
import {Link, useLocation} from 'react-router-dom';
import s from './Notification.module.scss'
import SockJS from 'sockjs-client';
import Stomp from 'stompjs';
import Button from 'react-bootstrap/Button'
import {RiNotification2Fill, RiNotification2Line} from 'react-icons/ri'
import Spinner from 'react-bootstrap/esm/Spinner'
import {Root} from 'Root'
import {SessionContext} from 'Utils/sessions';
import Modal from 'react-bootstrap/Modal';
import {toast, ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Notifications = ({className}) => {
      const shouldDisplayInAppNotification = !useLocation().pathname.includes('/inbox');
      const {session, refreshSession} =  useContext(SessionContext);
      const [notifs, setNotifs] = useState(null)
      const [showNotifications, setShowNotifications] = useState(false)
      const [error, setError] = useState(null)
      const [importantNotification, setImportantNotification] = useState(null)
      const [showImportantNotification, setShowImportantNotification] = useState(false)
      const [registration, setRegistration] = useState(null);
      const [notificationsPermitted, setNotificationsPermitted] = useState(false);
      const [notificationToken, setNotificationToken] = useState(localStorage.getItem('notificationToken') || '');
      const [deviceId, setDeviceId] = useState(localStorage.getItem('deviceId') || `${crypto.randomUUID()}`);
      const [getPermissions, setGetPermissions] = useState(false)

      useEffect(() => {
        navigator.serviceWorker.addEventListener('message', event => {
          if (event.data.type === 'notification-received') {
            const notificationData = event.data.notificationData;
            if (shouldDisplayInAppNotification) {
              toast("New message! Go to your inbox to view more.", {
                position: toast.POSITION.TOP_CENTER,
              });
            }
            fetchNotifications();
            // Create a new CustomEvent. The first argument is the event name.
            const myEvent = new CustomEvent('new-notification-received', {threadId: notificationData.resourceId});
            // Dispatch the event on the document:
            document.dispatchEvent(myEvent);
          }
        });

        return () => {
          navigator.serviceWorker.removeEventListener('message', handleMessage);
        };
      }, []);

      useEffect(() => {
        document.addEventListener('thread-marked-read', (event) => {
          fetchNotifications();
        });
      }, []);

      const handleMessage = (event) => {
        if (event.data.type === 'push-received') {
          console.log('Message from service worker:', event.data.message);
          // Perform actions in your app based on the message
          alert(event.data.message)
        }
      }

      useEffect(() => {
        // Check for service worker support
        if ('serviceWorker' in navigator) {
          navigator.serviceWorker.register('/service-worker.js') // Path to your service worker file
          .then(serviceWorkerRegistration => {
            if (serviceWorkerRegistration) {
              setRegistration(serviceWorkerRegistration);
            }
          })
          .catch(err => console.error('Service Worker registration failed:', err));
        } else {
          console.error('Service Workers are not supported.');
        }
      }, []);

      useEffect(() => {
        // Check for notification support
        if (!("Notification" in window) || localStorage.getItem("notification.permission") === 'denied') {
          return;
        }

        // Request permission if not granted or denied
        if (Notification.permission === "default") {
          setGetPermissions(true);
        } else if (Notification.permission === "denied") {
          // toast.error(
          //   <div>Notifications are currently blocked for this site. To enable them:<br></br>
          //     1. Click the lock icon in the address bar.<br></br>
          //     2. Find 'Notifications'.<br></br>
          //     3. Select 'Allow'.
          //   </div>, {enableHtml: true});
        } else {
          setNotificationsPermitted(true);
        }
      }, []);

      useEffect(() => {
        if (registration && notificationsPermitted) {
          registration.pushManager.getSubscription().then((subscription) => {
            if (subscription) {
              // already subbed
            } else {
              subscribeAndSave();
            }
          });
        }
      }, [registration, notificationsPermitted]);

      const requestNotificationPermission = async () => {
        try {
          await Notification.requestPermission().then((permission) => {
            if (permission === 'granted') {
              setNotificationsPermitted(true);
            }

            setGetPermissions(false);
          })
        } catch (error) {
          console.error("Error requesting notification permission:", error);
        }
      };

      const declineNotificationPermission = () => {
        localStorage.setItem('notification.permission', 'denied')
        setGetPermissions(false);
        setNotificationsPermitted(false);
      }

      const subscribeAndSave = async () => {
        if (!registration) return;

        const applicationServerPublicKey = urlBase64ToUint8Array("BG0ggoqUoVWU6Iwet3Mm35fPBLtv1M4YJGzhr2zQlqwKoJjEcgSxxiro-b3jWEPelDxjyCg50ntXUflXR9KxnW4"); // Convert VAPID key

        try {
          const subscription = await registration.pushManager.subscribe({
            userVisibleOnly: true,
            applicationServerKey: applicationServerPublicKey
          }).catch((err) => console.log(`there's an error: ${err}`));
          if (!subscription) {
            return false
          }

          if (notificationToken === subscription.endpoint.replace("https://fcm.googleapis.com/fcm/send/", "")) {
            return;
          } else {
            if (notificationToken !== '') {
              Root.userApi.unRegisterDeviceToken(notificationToken, 'chrome', session.jwt);
            }

            const rawKey = subscription.getKey('p256dh');
            const p256dh = rawKey ? btoa(String.fromCharCode(...new Uint8Array(rawKey))) : null;
            const rawAuth = subscription.getKey('auth');
            const auth = rawAuth ? btoa(String.fromCharCode(...new Uint8Array(rawAuth))) : null;

            const token = {keys: {auth: auth, p256dh: p256dh}, endpoint: subscription.endpoint}

            const platform = 'chrome' in window ? 'Chrome' : 'Safari';

            // Send subscription to server
            Root.userApi.registerDeviceToken(deviceId, JSON.stringify(token), platform, session.jwt)
            .then((res) => {
              if (res.status === 200) {
                const fbep = subscription.endpoint.replace("https://fcm.googleapis.com/fcm/send/", "");
                setNotificationToken(fbep);
                localStorage.setItem('notificationToken', fbep);
                localStorage.setItem('deviceId', deviceId);
              }
            })
            .catch(err => console.log(err));
          }
        } catch (error) {
          console.error('Failed to subscribe the user: ', error);
        }
      };

      useEffect(() => {
        if (!('Notification' in window)) {
          const sock = new SockJS(`${Root.baseURL()}/api/v2/notificationsocket`);
          const stompClient = Stomp.over(sock);
          stompClient.debug = function (){}; //do nothing
          stompClient.connect({'Authorization': `Bearer: ${session.jwt}`}, (frame) => {
            stompClient.subscribe(`/messaging/${session.userName}/general-notifications`, (response) => {
              fetchNotifications();
            });
          });
        }
      }, [notifs]);

      // Utility function to convert VAPID key (from: https://web-push-book.gauntface.com/demos/common/js/base64-to-uint8array.js)
      function urlBase64ToUint8Array(base64String) {
        const padding = '='.repeat((4 - base64String.length % 4) % 4);
        const base64 = (base64String + padding)
        .replace(/-/g, '+')
        .replace(/_/g, '/');

        const rawData = window.atob(base64);
        const outputArray = new Uint8Array(rawData.length);

        for (let i = 0; i < rawData.length; ++i) {
          outputArray[i] = rawData.charCodeAt(i);
        }
        return outputArray;
      }

      function sortMessages(messages){
        return messages.sort((a, b) =>
        a.dispatchTimestamp - b.dispatchTimestamp
      ).reverse()
    }

    function getSortedNotifs(notifications) {
      var messages = []
      messages.push(...notifications)
      // if (session.profile) {
      //   messages.push(actionItems.personalityProfile)
      // }
      return sortMessages(messages)
    }

    function fetchNotifications() {
      Root.userApi.getAllNotifications(session.jwt)
      .then((rsp) => {
        setNotifs(getSortedNotifs(rsp.data))
        detectImportantMessage(rsp.data)
      })
      .catch((err)=> {
        setImportantNotification(null);
        setShowImportantNotification(false)
        setError('Unable to refresh notifications')})
      }

      function pulseCheck() {
        Root.miscApi.serverPulseCheck()
        .then(() => {
        })
        .catch(()=> {
            toast.error("It looks like the server is restarting, please refresh in a few seconds!");
            window.location.href = '/login'
        })
      }

      function detectImportantMessage(messages) {
        if (messages) {
          for (let i = 0; i < messages.length; i++) {
            if (messages[i].type && messages[i].type.toLowerCase() == 'important') {
              setImportantNotification(messages[i]);
              setShowImportantNotification(true)
              return;
            }
          }
        }
      }

      useEffect(()=>{
        pulseCheck()
        var messages = []
        // messages.push(actionItems.personalityProfile)
        setNotifs(messages)
        fetchNotifications()
      },[])

      function markAsRead(notificationId) {
        Root.userApi.markNotificationRead(notificationId, session.jwt).then(() => {
          fetchNotifications();
        }).catch(err => console.log(err))
      }

    return      <>
     <Button className={`btnLink ${className}`} onClick={()=> setShowNotifications(true)} ><p style={{color:'#ffff', verticalAlign: 'sub'}}>{(notifs && notifs.length > 0) ? <RiNotification2Fill className={s.notificationBell}/> : <RiNotification2Line className={s.notificationBell} />}{(notifs && notifs.length > 0) ? '('+ notifs.length + ')' : ''}</p></Button>
      <Modal fullscreen={'md-down'} show={showNotifications} onHide={()=> setShowNotifications(false)}>
        <Modal.Header closeButton/>
        <Modal.Title>
          <h3 style={{textAlign: 'center'}}>Notifications</h3>
        </Modal.Title>
        <Modal.Body>
          {importantNotification && showImportantNotification &&
              <>
                {importantNotification.link && <div>
                  <Link className='btnLink fs-13' onClick={() => { markAsRead(importantNotification.id); }} to={importantNotification.link}>{importantNotification.action || 'Click to view'}</Link>
                </div>}
                {!importantNotification.link && <div>
                  <Link className='btnLink fs-13' onClick={() => { markAsRead(importantNotification.id); }}>Dismiss</Link>
                </div>}
              </>
          }
          {notifs ?  <MessageTable session={session} messages={notifs} fetchNotifs={fetchNotifications}/> :
              <Spinner style={{color:"rgb(16, 142, 115)"}} animation="border" role="status">
              </Spinner>
          }
          {error && <p className='text-muted'>{error}</p>}
        </Modal.Body>
      </Modal>
    {
      <Modal show={getPermissions} onHide={()=>setGetPermissions(false)}>
      <Modal.Header closeButton/>
      <Modal.Body>
      <h3>Permissions Needed</h3>
      <p>To receive notifications, you must first grant the necessary permissions.</p>
        <Button onClick={()=> { requestNotificationPermission() }} className='ms-2 btnLink fw-bold fs-16'>Allow for notifications</Button>
        <Button onClick={()=> { declineNotificationPermission() }} className='ms-2 btnLink red fw-bold fs-16'>Dismiss</Button>
      </Modal.Body>
      </Modal>
    }
    <ToastContainer theme="dark" autoClose={5000} position="bottom-center" />
    </>
  }

  export default (Notifications);


  const MessageTable = ({messages, session, fetchNotifications}) => {

    function markAsRead(id) {
      Root.userApi.markNotificationRead(id, session.jwt).then(() => {
        fetchNotifications();
      }).catch(err => console.log(err))
    }

    // // Types = ["BANNER", "MENTION", "important"]
    // function createPostLink(input, type){
    //   if(type === "important") {
    //     return input.link;
    //   }
    //
    //   var resource = JSON.parse(input);
    //   if (type.toUpperCase() === "MENTION") {
    //     var instution = "general"
    //     if(resource.institution && resource.institution.length > 1 ){
    //       instution = resource.institution
    //     }
    //     return `/forum/${instution}/${resource.root}`
    //   }
    //   if (type.toUpperCase() === "BANNER") {
    //     return `/${resource.institution}`
    //   }
    //   return null
    // }

    return (
      <>
      {messages && messages.length === 0 && <p className='fs-13 text-muted'>No notifications</p>}
      {messages.map((message, idx) => <> <div key={idx}>
      {!!message.subject ? <p style={{fontSize:'15px', fontWeight:'600', marginBottom:'5px'}}>{message.subject}</p> : <></>}
      <p style={{marginBottom:'5px'}}>{message.message}</p>
      <div style={{display:'flex', justifyContent: 'space-between', width: '100%'}}>
      {message.link &&
        <div>
        <Link className='btnLink fs-13' onClick={() => { markAsRead(message.id); }} to={message.link}>{message.action || 'Click to view'}</Link>
        </div>}
        {message.id &&
          <div style={{marginRight: '18px'}}>
          <Link className='btnLink fs-13 red' onClick={() => { markAsRead(message.id); }}>Dismiss</Link>
          </div>}
          </div>
          </div>
          <hr className='my-3' style={{backgroundColor:'black', height: 3}}/>
          </>)}
          </>
        );
      };
